import {
	AttachedFile,
	FileType,
	FloraAIChat,
	FloraAICredits,
	FloraDossierDocument,
	FloraHeroTopic,
	FloraLibraryDocument,
	FloraLibraryFilter,
} from '../types/flora-ai.types';

const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const mockDossierDocuments: FloraDossierDocument[] = [
	{ id: '1', name: 'analise_de_solo_agrilabs.pdf', pages: 12 },
	{ id: '2', name: 'laudo_foliar_talhao_04.pdf', pages: 15 },
	{ id: '3', name: 'analise_de_foliar_agrilabs.pdf', pages: 3 },
];

export const mockHeroTopics: FloraHeroTopic[] = [
	{ id: '1', number: '01', label: 'O que mudou entre a análise de maio e de janeiro?' },
	{ id: '2', number: '02', label: 'Monte um calendário de adubação a partir da recomendação' },
	{ id: '3', number: '03', label: 'As aplicações registradas batem com a receita agronômica?' },
];

export const mockAttachedFiles: AttachedFile[] = [
	{
		id: '1',
		name: 'aplicacoes_jan_2026.xls',
		type: FileType.XLS,
		uploadedAt: new Date('2026-01-15'),
	},
	{
		id: '2',
		name: 'analise_de_solo_agrilabs.pdf',
		type: FileType.PDF,
		uploadedAt: new Date('2026-01-14'),
	},
	{
		id: '3',
		name: 'diagrama_do_cerrado.png',
		type: FileType.PNG,
		uploadedAt: new Date('2026-01-13'),
	},
	{
		id: '4',
		name: 'ebook_segredos_do_cafe.pdf',
		type: FileType.PDF,
		uploadedAt: new Date('2026-01-12'),
	},
	{
		id: '5',
		name: 'fazenda_formigueiro.pdf',
		type: FileType.PDF,
		uploadedAt: new Date('2026-01-11'),
	},
	{
		id: '6',
		name: 'sha36lwdslrofd57k.pdf',
		type: FileType.PDF,
		uploadedAt: new Date('2026-01-10'),
	},
	{
		id: '7',
		name: 'catalogo_de_especies.pdf',
		type: FileType.PDF,
		uploadedAt: new Date('2026-01-09'),
	},
];

export const mockFloraChats: FloraAIChat[] = [
	{
		id: '1',
		title: 'Nova Coversa',
		lastMessage: '',
		timestamp: new Date(),
		dossierCount: 3,
	},
	{
		id: '2',
		title: 'Acidez no talhão 4',
		lastMessage: 'Sim, vale calcariar. Para levar V% A 60%...',
		timestamp: new Date(Date.now() - DAY_IN_MS),
		dossierCount: 1,
	},
	{
		id: '3',
		title: 'Janela de irrigação - café conilon',
		lastMessage: 'Com 14 mm de lâmina e ET. de 4.1 mm/dia...',
		timestamp: new Date(Date.now() - DAY_IN_MS),
		dossierCount: 3,
	},
	{
		id: '4',
		title: 'Espécies de cobertura para o cerrado',
		lastMessage: 'Crotalana speciailibilis funciona bem para o seu...',
		timestamp: new Date(Date.now() - 20 * DAY_IN_MS),
		dossierCount: 32,
	},
	{
		id: '5',
		title: 'Como usar Python para análise de Colheita...',
		lastMessage: 'Com o ambiente virtual criado, você precisa instalar...',
		timestamp: new Date(Date.now() - 22 * DAY_IN_MS),
		dossierCount: 5,
	},
];

export const mockLibraryFilters: FloraLibraryFilter[] = [
	{ id: 'all', label: 'Todos' },
	{ id: 'pdf', label: 'PDF' },
	{ id: 'sheets', label: 'Planilhas' },
	{ id: 'images', label: 'Imagens' },
];

export const mockLibraryDocuments: FloraLibraryDocument[] = [
	{
		id: '1',
		name: 'analise_de_solo_agrilabs.pdf',
		kind: 'pdf',
		meta: '1.8 MB - 12 páginas - 02 fev',
		inDossier: true,
	},
	{
		id: '2',
		name: 'análise_00001.pdf',
		kind: 'pdf',
		meta: '2.8 MB - 5 páginas - 25 jan',
		inDossier: false,
	},
	{
		id: '3',
		name: 'laudo_foliar_talhao_04.pdf',
		kind: 'pdf',
		meta: '2.5 MB - 15 páginas - 12 jan',
		inDossier: true,
	},
	{
		id: '4',
		name: 'analise_de_foliar_agrilabs.pdf',
		kind: 'pdf',
		meta: '2.2 MB - 3 páginas - 12 jan',
		inDossier: true,
	},
	{
		id: '5',
		name: 'diagrama_4474757575467.png',
		kind: 'images',
		meta: '6.2 MB - 1920x1080 - 11 jan',
		inDossier: false,
	},
	{
		id: '6',
		name: 'analise_de_solo_agrilabs.pdf',
		kind: 'pdf',
		meta: '1.8 MB - 12 páginas - 02 fev',
		inDossier: false,
	},
	{
		id: '7',
		name: 'Screnshot_57mfmk5744546.png',
		kind: 'images',
		meta: '2.2 MB - 1920x1080 - 11 jan',
		inDossier: false,
	},
	{
		id: '8',
		name: 'analise_de_solo_agrilabs.pdf',
		kind: 'pdf',
		meta: '1.8 MB - 12 páginas - 02 fev',
		inDossier: false,
	},
];

export const mockCreditsData: FloraAICredits = {
	used: 240,
	total: 500,
	renewDate: '12 de Fevereiro',
	planName: 'Flora Pro',
};

export const mockAdminCreditsData: FloraAICredits = {
	used: 0,
	total: 999999,
	renewDate: 'Ilimitado',
	planName: 'Admin',
};
